'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _dec2, _class, _class2, _temp;

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactRedux = require('react-redux');

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _tmtUiKit = require('tmt-ui-kit');

var _session = require('redux/modules/session');

var _info = require('redux/modules/info');

var _popup = require('redux/modules/popup');

var _customize = require('redux/modules/customize');

var _suggestion = require('redux/modules/suggestion');

var _reactRouterRedux = require('react-router-redux');

var _initialLoadSuccess = require('redux/modules/initialLoadSuccess');

var _reduxAsyncConnect = require('redux-async-connect');

var _Nav = require('components/Nav/Nav');

var _Nav2 = _interopRequireDefault(_Nav);

var _MobileMenu = require('components/Nav/MobileMenu');

var _MobileMenu2 = _interopRequireDefault(_MobileMenu);

var _Toast = require('components/Toast/Toast');

var _Toast2 = _interopRequireDefault(_Toast);

var _Footer = require('containers/Footer/Footer');

var _Footer2 = _interopRequireDefault(_Footer);

var _Modal = require('components/General/Modal/Modal');

var _Modal2 = _interopRequireDefault(_Modal);

var _Login = require('components/Nav/Login');

var _Login2 = _interopRequireDefault(_Login);

var _Signup = require('components/Nav/Signup');

var _Signup2 = _interopRequireDefault(_Signup);

var _LoginSignup = require('components/Nav/LoginSignup');

var _LoginSignup2 = _interopRequireDefault(_LoginSignup);

var _Forgot = require('components/Nav/Forgot');

var _Forgot2 = _interopRequireDefault(_Forgot);

var _MainLoader = require('components/Loader/MainLoader');

var _MainLoader2 = _interopRequireDefault(_MainLoader);

var _MobileApp = require('components/MobileApp/MobileApp');

var _MobileApp2 = _interopRequireDefault(_MobileApp);

var _SearchMobile = require('components/SearchTrips/SearchMobile');

var _SearchMobile2 = _interopRequireDefault(_SearchMobile);

var _WeChat = require('components/Popup/WeChat');

var _WeChat2 = _interopRequireDefault(_WeChat);

var _CancellationPolicy = require('components/CancellationPolicy/CancellationPolicy');

var _CancellationPolicy2 = _interopRequireDefault(_CancellationPolicy);

var _superagent = require('superagent');

var _superagent2 = _interopRequireDefault(_superagent);

var _reactGa = require('react-ga');

var _reactGa2 = _interopRequireDefault(_reactGa);

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _socket = require('socket.io-client');

var _socket2 = _interopRequireDefault(_socket);

var _toast = require('redux/modules/toast');

var toastActions = _interopRequireWildcard(_toast);

var _helpers = require('utils/helpers');

var _price = require('utils/price');

var _styled = require('theme/styled.theme');

var _styled2 = _interopRequireDefault(_styled);

var _app = require('../../redux/modules/app');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
  App: {
    displayName: 'App'
  }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
  filename: '/home/runner/work/redux-frontend/redux-frontend/src/containers/App/App.js',
  components: _components,
  locals: [],
  imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
  return function (Component) {
    return _reactTransformCatchErrors2(Component, id);
  };
}

_moment2.default.tz.setDefault('Asia/Bangkok');
// import { openSubscribe, openWeChatPopup } from 'redux/modules/popup';

// import SubscribeDtac from 'components/Popup/SubscribeDtac';
var CountrySelectorModal = _tmtUiKit.Modal.CountrySelectorModal;

var App = _wrapComponent('App')((_dec = (0, _reduxAsyncConnect.asyncConnect)([{
  promise: function promise(_ref) {
    var _ref$store = _ref.store,
        dispatch = _ref$store.dispatch,
        getState = _ref$store.getState;

    var promises = [];
    promises.push(dispatch((0, _info.loadCombinedDynamic)()));
    if (!getState().info.combinedStaticLoaded) {
      promises.push(dispatch((0, _info.loadCombinedStatic)(getState().language.locale || 'en')));
    }
    return _promise2.default.all(promises).catch(function () {
      return dispatch((0, _initialLoadSuccess.loadServerError)());
    });
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.session.user,
    path: state.routing.locationBeforeTransitions.pathname,
    headTags: state.info.headTags,
    sessionData: state.session.data,
    isOpenLogin: state.session.openLogin,
    isOpenSignup: state.session.openSignup,
    isOpenForgot: state.session.openForgot,
    isOpenLoginSignup: state.session.openLoginSignup,
    isOpenMobileApp: state.session.openMobileApp,
    isOpenMobileQuickSearch: state.session.openMobileQuickSearch,
    isOpenCountNumUser: state.session.openCountNumUser,
    // isOpenSubscribe: state.popup.openSubscribe,
    // isOpenSet: state.session.openSet,
    isPageChanged: state.session.isPageChanged,
    isVisitBooking: state.session.isVisitBooking,
    // isOpenCustomizeTripPopup: state.customize.openCustomizeTripPopup,
    query: state.routing.locationBeforeTransitions.query,
    filter: state.search.filter,
    // filterOld: state.searchOld.filter,
    locale: state.language.locale,
    lockIds: state.lockscreen.ids,
    // lockCount: state.lockscreen.count,
    verifyEmailPushed: state.toast.verifyEmailPushed,
    userConfig: state.info.userConfig,
    isLoggedIn: state.session.isLoggedIn,
    messages: state.language.messages,
    step: state.popup.step,
    data: state.session.data,
    toasts: state.toast.toasts,
    //
    weChatEveryLink: state.info.siteConfigs.weChatEveryLink,
    isOpenWeChatPopup: state.popup.isOpenWeChatPopup,
    loginSignUpTab: state.session.loginSignUpTab
  };
}, (0, _extends3.default)({
  pushState: _reactRouterRedux.push,
  openLogin: _session.openLogin,
  openSignup: _session.openSignup,
  openForgot: _session.openForgot,
  openLoginSignup: _session.openLoginSignup,
  openMobileApp: _session.openMobileApp,
  openCountNumUser: _session.openCountNumUser,
  // openSubscribe,
  openCustomizeTripPopup: _customize.openCustomizeTripPopup,
  openWeChatPopup: _popup.openWeChatPopup,
  setCancellationPolicy: _session.setCancellationPolicy,
  // openSet,
  setIsPageChanged: _session.setIsPageChanged,
  setSessionData: _session.setSessionData,
  loadSessionData: _session.loadSessionData,
  setText: _suggestion.setText,
  setWithPromo: _session.setWithPromo,
  setOldPromo: _session.setOldPromo,
  setPromoInput: _session.setPromoInput,
  setLocalSessionData: _session.setLocalSessionData
}, toastActions, {
  sendUserType: _session.sendUserType,
  getPartnerConfig: _app.getPartnerConfig
})), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(App, _Component);

  function App(props) {
    (0, _classCallCheck3.default)(this, App);

    // this.triggerSubscribe = this.triggerSubscribe.bind(this);
    var _this = (0, _possibleConstructorReturn3.default)(this, (App.__proto__ || (0, _getPrototypeOf2.default)(App)).call(this, props));

    _this.onCloseLogin = function () {
      _this.props.openLogin(false);
    };

    _this.onCloseSignup = function () {
      _this.props.openSignup(false);
    };

    _this.onCloseForgot = function () {
      _this.props.openForgot(false);
    };

    _this.onCloseLoginSingup = function () {
      _this.props.openLoginSignup(false);
    };

    _this.onCloseMobileApp = function () {
      _this.props.openMobileApp(false);
    };

    _this.onCloseCustomizeTripPopup = function () {
      _this.props.openCustomizeTripPopup(false);
    };

    _this.connectToSocket = function () {
      var userId = _this.props.user ? _this.props.user._id : null;
      var socketURL = '/notification';
      var token = (0, _helpers.getCookie)('access_token');
      var options = {
        transports: ['polling', 'websocket'],
        'force new connection': true,
        path: '/ws',
        query: 'token=' + token + '&userID=' + userId
      };
      _this.state.client = _socket2.default.connect(socketURL, options);
      _this.state.client.on('connect', function () {
        _this.state.connecting = false;
        _this.state.client.emit('set noti room', userId);
        _this.receiveNotification(_this.state.client);
      });
    };

    _this.receiveNotification = function (client) {
      client.on('pushNotification', function (notification) {
        _this.props.pushNotification(notification);
      });
    };

    _this.isfullWidth = function () {
      if (_this.props.path.startsWith('/to')) {
        return true;
      }
      return false;
    };

    _this.isHideMenu = function () {
      if (_this.props.path.match(/^\/booking(?!.*\/success).*$/)) {
        return true;
      }
      return false;
    };

    _this.isBareComponent = function () {
      if (_this.props.path.startsWith('/thumbnail')) {
        return true;
      }
      return false;
    };

    _this.isAllowGuest = function () {
      if (_this.props.path.startsWith('/booking') || _this.props.path.startsWith('/trip')) {
        return true;
      }
      return false;
    };

    _this.triggerClassifyUser = _this.triggerClassifyUser.bind(_this);

    if (!(typeof _this.triggerClassifyUser === 'function')) {
      throw new TypeError('Value of "this.triggerClassifyUser" violates contract.\n\nExpected:\n() => any\n\nGot:\n' + _inspect(_this.triggerClassifyUser));
    }

    _this.handleClassifyUser = _this.handleClassifyUser.bind(_this);

    if (!(typeof _this.handleClassifyUser === 'function')) {
      throw new TypeError('Value of "this.handleClassifyUser" violates contract.\n\nExpected:\n(any) => any\n\nGot:\n' + _inspect(_this.handleClassifyUser));
    }

    _this.handleCloseClassifyUser = _this.handleCloseClassifyUser.bind(_this);

    if (!(typeof _this.handleCloseClassifyUser === 'function')) {
      throw new TypeError('Value of "this.handleCloseClassifyUser" violates contract.\n\nExpected:\n() => any\n\nGot:\n' + _inspect(_this.handleCloseClassifyUser));
    }

    _this.state = {
      client: {},
      connecting: false
      // tripVisited: false,
    };
    return _this;
  }

  (0, _createClass3.default)(App, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.state = {
        client: {},
        connecting: false
      };
      this.connectToSocket = this.connectToSocket.bind(this);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var affId = this.props.query.affid || (0, _helpers.getCookie)('reference_id');
      this.props.getPartnerConfig(affId);
      var objectFitImages = require('object-fit-images');
      objectFitImages();
      if (!this.props.query.robotTest && !this.props.path.startsWith('/pay') && this.props.locale !== 'th' && this.props.locale !== 'zh' && !this.props.isPageChanged && !(0, _helpers.isDusitApp)()) {
        this.triggerClassifyUser();
      }
      if (this.props.query && this.props.query.signup === 'true') {
        this.props.openSignup();
      }
      if (this.props.query && this.props.query.login === 'true') {
        this.props.openLogin();
      }
      if (this.props.query.utm_campaign && document) {
        document.cookie = 'utm_campaign=' + this.props.query.utm_campaign + '; path=/;';
      }
      if (this.props.query && this.props.query.affid && document) {
        var expiryDate = new Date();
        expiryDate.setMonth(expiryDate.getMonth() + 1);
        document.cookie = 'reference_id=' + this.props.query.affid + '; expires=' + expiryDate + '; path=/;';
      }
      if ((0, _helpers.isDusitApp)() && document) {
        var _expiryDate = new Date();
        _expiryDate.setMonth(_expiryDate.getMonth() + 1);
        document.cookie = 'reference_id=DUSITAPP; expires=' + _expiryDate + '; path=/;';
      }

      if (this.props.weChatEveryLink) {
        setTimeout(function () {
          _this2.props.openWeChatPopup();
        }, 5000);
      }
      var uniqueId = (0, _helpers.getCookie)('unique_id');
      // const userId = this.props.user ? this.props.user._id : null;
      var analyticsParams = [{
        trackingId: _config2.default.gaTokens[this.props.locale],
        debug: false,
        gaOptions: {
          clientId: uniqueId,
          userId: this.props.user ? this.props.user._id : null
        }
      }];
      if (_config2.default.isAustraliaSite) {
        analyticsParams.push({
          trackingId: _config2.default.gaTokens.au,
          debug: false,
          gaOptions: {
            clientId: uniqueId,
            userId: this.props.user ? this.props.user._id : null,
            name: 'auTracker'
          }
        });
      }

      _reactGa2.default.initialize(analyticsParams);
      _reactGa2.default.plugin.require('displayfeatures', undefined, ['auTracker']);
      _reactGa2.default.set({
        dimension4: this.props.userConfig.marketingPopupType,
        dimension5: this.props.userConfig.advanceSearchType,
        dimension6: this.props.userConfig.searchFilterType,
        dimension7: this.props.userConfig.omitBookingFee ? 'true' : 'false',
        dimension8: this.props.userConfig.searchFilterType === 'AC' ? 'true' : 'false',
        dimension9: this.props.userConfig.tourTypeEnabled ? 'true' : 'false',
        dimension10: 'true',
        dimension11: this.props.userConfig.showHomeInspirations ? 'Inspiration' : 'Trip',
        dimension12: this.props.userConfig.tripOneTab ? 'One Section' : 'Tabs',
        dimension13: this.props.userConfig.tripBookNow ? 'true' : 'false',
        dimension14: this.props.userConfig.searchPaginationEnabled ? 'true' : 'false',
        dimension15: this.props.userConfig.tripOpenNewTab ? 'true' : 'false',
        dimension17: this.props.userConfig.searchFilterEnabled ? 'true' : 'false',
        dimension18: this.props.userConfig.hideLightning ? 'true' : 'false',
        dimension20: this.props.userConfig.paypalFirst ? 'true' : 'false'
      }, ['auTracker']);
      // ga.set({ dimension4: this.props.userConfig.marketingPopupType }, ['auTracker']);
      // ga.set({ dimension5: this.props.userConfig.advanceSearchType }, ['auTracker']);
      // ga.set({ dimension6: this.props.userConfig.searchFilterType }, ['auTracker']);
      // ga.set({ dimension7: this.props.userConfig.omitBookingFee ? 'true' : 'false' }, ['auTracker']);
      // ga.set({ dimension8: this.props.userConfig.searchFilterType === 'AC' ? 'true' : 'false' }, ['auTracker']);
      // ga.set({ dimension9: this.props.userConfig.tourTypeEnabled ? 'true' : 'false' }, ['auTracker']);
      // ga.set({ dimension10: 'true' }, ['auTracker']);
      // ga.set({ dimension11: this.props.userConfig.showHomeInspirations ? 'Inspiration' : 'Trip' }, ['auTracker']);
      // ga.set({ dimension12: this.props.userConfig.tripOneTab ? 'One Section' : 'Tabs' }, ['auTracker']);
      // ga.set({ dimension13: this.props.userConfig.tripBookNow ? 'true' : 'false' }, ['auTracker']);
      // ga.set({ dimension14: this.props.userConfig.searchPaginationEnabled ? 'true' : 'false' }, ['auTracker']);
      // ga.set({ dimension15: this.props.userConfig.tripOpenNewTab ? 'true' : 'false' }, ['auTracker']);
      // ga.set({ dimension17: this.props.userConfig.searchFilterEnabled ? 'true' : 'false' }, ['auTracker']);
      // ga.set({ dimension18: this.props.userConfig.hideLightning ? 'true' : 'false' }, ['auTracker']);
      // ga.set({ dimension19: this.props.userConfig.isDefaultTHB ? 'true' : 'false' }, ['auTracker']);
      // ga.set({ dimension20: this.props.userConfig.paypalFirst ? 'true' : 'false' }, ['auTracker']);
      if (this.props.query && this.props.query.login_success === 'true') {
        _reactGa2.default.set({ referrer: _config2.default.baseURL.en }, ['auTracker']);
        if (this.props.isLoggedIn) {
          this.props.toastOAuthLoginSuccess();
        }
      }

      var promises = [];
      var data = {};
      var localData = {};
      if (this.props.data.userType && this.props.data.userType.type) {
        _reactGa2.default.set({ dimension1: this.props.data.userType.type }, ['auTracker']);
      } else if ((this.props.data.country !== 'TH' || affId) && !this.props.data.userType) {
        if (window.hj) {
          window.hj('trigger', 'record');
        }
        if (affId === 'DUSITAPP') {
          data.userType = { type: 'DUSIT', selected_at: (0, _moment2.default)().toDate() };
          _reactGa2.default.set({ dimension1: 'DUSIT' }, ['auTracker']);
          _reactGa2.default.event({ category: 'User', action: 'Classify User' }, ['auTracker']);
        }
      }
      if (this.props.filter && this.props.filter.quantity) {
        data.quantity = this.props.filter.quantity;
        localData.quantity = this.props.filter.quantity;
      }
      if (this.props.query && this.props.query.source) {
        data.source = this.props.query.source;
      }
      if (this.props.query && this.props.query.promo) {
        data.promo = this.props.query.promo;
        promises.push(this.props.setPromoInput(this.props.query.promo));
        if (!this.props.query.withpromo) {
          promises.push(this.props.setOldPromo());
        }
      } else if (this.props.path.startsWith('/digi')) {
        data.promo = 'DG40';
        data.currency = 'MYR';
      } else if (this.props.path.startsWith('/dtac')) {
        data.promo = 'AUTO300';
      }
      if (this.props.path.startsWith('/buffet')) {
        data.currency = 'SGD';
        localData.currency = 'SGD';
      }
      if (this.props.path.startsWith('/booking') && !this.props.data.is_booking_opened) {
        data.is_booking_opened = true;
      }
      if (this.props.query && this.props.query.rc) {
        data.referral_code = this.props.query.rc;
      }
      if (this.props.query && this.props.query.withpromo) {
        promises.push(this.props.setWithPromo());
      }
      if ((0, _keys2.default)(data).length > 0) {
        promises.push(this.props.setSessionData(data));
      }
      if ((0, _keys2.default)(localData).length > 0) {
        promises.push(this.props.setLocalSessionData(localData));
      }
      _promise2.default.all(promises).then(function () {
        return _this2.props.loadSessionData();
      });

      var path = this.props.path;

      if (!path.startsWith('/thumbnail/')) {
        _reactGa2.default.pageview(this.props.path, ['auTracker']);
      }

      // const mixpanel = require('mixpanel-browser');
      // mixpanel.init(config.mixpanel.token);
      // if (userId) {
      //   if (mixpanel && mixpanel.identify) {
      //     mixpanel.identify(userId);
      //   }
      // } else {
      //   if (mixpanel && mixpanel.identify) {
      //     mixpanel.identify(uniqueId);
      //   }
      // }
      // mixpanel.track('Page View', { path: this.props.path });
      _superagent2.default.post('/api/logs').send({
        namespace: 'pageview',
        title: 'Page View',
        data: { path: this.props.path }
      }).end();
      if (path.startsWith('/to') || path.startsWith('/trip/') || path.startsWith('/activity') || path.startsWith('/booking/') || path.startsWith('/thumbnail/') || path.startsWith('/local-expert/') || path.match(/^\/dashboard\/booking\/[0-9a-f]+$/)) {
        document.body.className = 'hide-zopim';
      }
      if (!this.state.client.connected && this.props.user && this.props.user._id) {
        this.state.connecting = true;
        this.connectToSocket();
      }

      if (window.zE && this.props.isLoggedIn) {
        window.zE(function () {
          if (window.zE.identify) {
            window.zE.identify({
              name: _this2.props.user.name.first + ' ' + _this2.props.user.name.last,
              email: _this2.props.user.email
            });
          }
        });
      }
      if (!(0, _helpers.getCookie)('site_visited')) {
        document.cookie = 'site_visited=true; path=/;';
      }

      var _props = this.props,
          user = _props.user,
          toasts = _props.toasts;

      var pathVerify = path === '/dashboard/verification';
      var pathBooking = path === '/booking/new';
      var isCheckDateVerify = (0, _moment2.default)(user.created_at).isBefore('2019-01-01');
      var toast = toasts.find(function (c) {
        return c.type === 'noti-verify';
      });

      if (!pathVerify && !pathBooking) {
        if (!(0, _helpers.isCheckVerify)(user) && isCheckDateVerify && !toast) {
          this.props.pushNotiVerify();
        }
      } else if (pathVerify || pathBooking) {
        if (!(0, _helpers.isCheckVerify)(user) && isCheckDateVerify && toast) {
          this.props.closeNotiVerify(toast.id);
        }
      }
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps) {
      if (!this.state.client.connected && this.props.user && this.props.user._id && !this.state.connecting) {
        this.state.connecting = true;
        this.connectToSocket();
      }
      if (!nextProps.user && this.state.client.connected) {
        this.state.client.disconnect();
      }
      if (!this.props.isOpenMobileQuickSearch && nextProps.isOpenMobileQuickSearch) {
        document.body.className = 'hide-zopim';
      }
      if (this.props.data.redeem && this.props.data.redeem.code && !nextProps.data.redeem) {
        this.props.closeToast(this.props.data.redeem.code);
      }
      // const mixpanel = require('mixpanel-browser');
      var _props2 = this.props,
          user = _props2.user,
          toasts = _props2.toasts;

      var pathVerify = nextProps.path === '/dashboard/verification';
      var pathBooking = nextProps.path === '/booking/new';
      var isCheckDateVerify = (0, _moment2.default)(user.created_at).isBefore('2019-01-01');
      var toast = toasts.find(function (c) {
        return c.type === 'noti-verify';
      });

      if (nextProps.path !== this.props.path) {
        if (pathVerify && toast) {
          if (!(0, _helpers.isCheckVerify)(user) && isCheckDateVerify) {
            this.props.closeNotiVerify(toast && toast.id);
          }
        }
        if (!pathVerify && !pathBooking && toast && toast.closedNoti === true) {
          if (!(0, _helpers.isCheckVerify)(user) && isCheckDateVerify) {
            this.props.openNotiVerify(toast && toast.id);
          }
        }
        // if (!this.props.query.robotTest &&
        //   !this.props.path.startsWith('/pay') &&
        //   this.props.locale !== 'th' &&
        //   this.props.locale !== 'zh' &&
        //   !this.props.isPageChanged &&
        //   !isDusitApp()
        // ) {
        //   // this.triggerSubscribe();
        //   setTimeout(() => {
        //     if (this.props.data &&
        //       this.props.data.redeem &&
        //       this.props.data.redeem.code &&
        //       this.props.data.redeem.type !== 'redeem' &&
        //       !this.props.isVisitBooking
        //     ) {
        //       const { redeem } = this.props.data;
        //       this.props.pushRedeemReminder(redeem);
        //     }
        //   }, 10000);
        // }
        // if (this.props.user && (!this.props.user.verification || !this.props.user.verification.email_verified) && !this.props.verifyEmailPushed && nextProps.path.startsWith('/dashboard')) {
        //   this.props.pushVerifyEmail();
        // }
        if (!this.props.isPageChanged) this.props.setIsPageChanged();
        _reactGa2.default.pageview(nextProps.path, ['auTracker']);
        // mixpanel.track('Page View', { path: nextProps.path });
        _superagent2.default.post('/api/logs').send({
          namespace: 'pageview',
          title: 'Page View',
          data: { path: nextProps.path }
        }).end();
        if (window.hj) {
          window.hj('vpv', nextProps.path);
        }
        if (window.$zopim) {
          // zopim should be loaded
          window.$zopim(function () {
            if (!window.location.origin) {
              window.location.origin = window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
            }
            window.$zopim.livechat.sendVisitorPath({
              url: window.location.origin + nextProps.path,
              title: document.title
            });
          });
        }
        if (nextProps.path.startsWith('/to') || nextProps.path.startsWith('/trip/') || nextProps.path.startsWith('/activity') || nextProps.path.startsWith('/booking/') || nextProps.path.startsWith('/thumbnail/') || nextProps.path.match(/^\/dashboard\/booking\/[0-9a-f]+$/)) {
          document.body.className = 'hide-zopim';
        } else {
          document.body.className = '';
        }
      }
      if (nextProps.lockIds && nextProps.lockIds.length > 0) {
        document.body.className = document.body.className.search('hide-zopim') < 0 ? 'lock-screen' : 'lock-screen hide-zopim';
      } else {
        document.body.className = document.body.className.search('hide-zopim') < 0 ? '' : 'hide-zopim';
      }
    }
    // onCloseCountNumUser = () => {
    //   this.props.sendUserType({
    //     userType: {
    //       type: 'close',
    //       selected_at: moment().toDate()
    //     }
    //   })
    //   .then( () => this.props.loadSessionData());
    //   this.props.openCountNumUser(false);
    // }
    // onCloseSubscribe = () => {
    //   this.props.openSubscribe(false);
    // }

  }, {
    key: 'handleClassifyUser',
    value: function handleClassifyUser(country) {
      var _this3 = this;

      this.props.sendUserType({
        userType: {
          type: country.label,
          selected_at: (0, _moment2.default)().toDate()
        },
        currency: (0, _price.getDefaultCurrency)(country.value)
      }).then(function () {
        return _this3.props.loadSessionData();
      }).then(function () {
        _reactGa2.default.set({ dimension1: country.label }, ['auTracker']);
        _reactGa2.default.event({ category: 'User', action: 'Classify User' }, ['auTracker']);
      });
      this.props.openCountNumUser(false);
    }
  }, {
    key: 'handleCloseClassifyUser',
    value: function handleCloseClassifyUser() {
      var _this4 = this;

      this.props.sendUserType({ userType: null }).then(function () {
        return _this4.props.loadSessionData();
      }).then(function () {
        _reactGa2.default.set({ dimension1: '' }, ['auTracker']);
      });
      this.props.openCountNumUser(false);
    }
  }, {
    key: 'triggerClassifyUser',
    value: function triggerClassifyUser() {
      var _this5 = this;

      setTimeout(function () {
        if (!_this5.props.data.userType
        // && !this.props.data.is_booking_opened
        && !(0, _helpers.isDusitApp)() && !_this5.props.path.startsWith('/booking')) {
          _this5.props.openCountNumUser();
        }
      }, 15000);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this6 = this;

      var _props3 = this.props,
          headTags = _props3.headTags,
          messages = _props3.messages,
          locale = _props3.locale,
          loginSignUpTab = _props3.loginSignUpTab;

      var path = this.props.path === '/' ? this.props.path : this.props.path.replace(/\/$/, '');
      if (this.isBareComponent()) {
        return this.props.children;
      }
      var meta = [{ 'property': 'fb:pages', 'content': '446772088701551' }, { 'property': 'og:site_name', 'content': messages.sitename + ' - ' + (headTags && headTags[path] && headTags[path].title || '') }, { 'property': 'msvalidate.01', 'content': '8CA81C9FEDC682F4BACAE96D8ECA8AD4' }];
      if (headTags && headTags[path] && headTags[path].description) {
        meta.push({ 'property': 'og:description', 'content': headTags[path].description });
        meta.push({ 'property': 'description', 'content': headTags[path].description });
      }
      if (headTags && headTags[path] && headTags[path].keywords) {
        meta.push({ 'property': 'keywords', 'content': headTags[path].keywords });
      }
      return _react3.default.createElement(
        _tmtUiKit.UIKitContext,
        {
          customTheme: _styled2.default,
          prefixPath: _config2.default.mediaPath,
          prefixAssetPath: _config2.default.uiKitAssetPath,
          facebookAppId: _config2.default.facebookAppId,
          googleClientId: _config2.default.googleClientId
        },
        _react3.default.createElement(
          'div',
          { className: 'root-parent' },
          _react3.default.createElement(_reactHelmet2.default, { title: headTags && headTags[path] && headTags[path].title || messages['home.title'],
            meta: meta,
            link: [{ rel: 'canonical', href: '' + _config2.default.baseURL[locale || 'en'] + path.replace(/\/$/, '') }]
          }),
          _react3.default.createElement(_SearchMobile2.default, null),
          _react3.default.createElement(
            _Modal2.default,
            { isOpen: this.props.isOpenLogin, onClose: this.onCloseLogin, id: 'login' },
            _react3.default.createElement(_Login2.default, { promo: this.props.query ? this.props.query.promo : null, discount: this.props.query ? this.props.query.discount : null, subTitle: this.props.query ? this.props.query.sub_title : null, omitCode: this.props.query ? this.props.query.omit_code === 'true' : false })
          ),
          _react3.default.createElement(
            _Modal2.default,
            { isOpen: this.props.isOpenSignup, onClose: this.onCloseSignup, id: 'signup' },
            _react3.default.createElement(_Signup2.default, { promo: this.props.query ? this.props.query.promo : null, discount: this.props.query ? this.props.query.discount : null, subTitle: this.props.query ? this.props.query.sub_title : null, omitCode: this.props.query ? this.props.query.omit_code === 'true' : false })
          ),
          this.props.isOpenLoginSignup && _react3.default.createElement(
            _Modal2.default,
            { isOpen: true, onClose: this.onCloseLoginSingup, zIndex: 10000, id: 'login-signup', style: { padding: 0 } },
            _react3.default.createElement(_LoginSignup2.default, { showSignup: loginSignUpTab === 'signup', allowGuest: this.isAllowGuest() })
          ),
          _react3.default.createElement(
            _Modal2.default,
            { isOpen: this.props.isOpenForgot, onClose: this.onCloseForgot, id: 'forgot', zIndex: 10000 },
            _react3.default.createElement(_Forgot2.default, null)
          ),
          _react3.default.createElement(
            _Modal2.default,
            { isOpen: this.props.isOpenMobileApp, onClose: this.onCloseMobileApp, id: 'mobile-app', style: { padding: 0 } },
            _react3.default.createElement(_MobileApp2.default, null)
          ),
          _react3.default.createElement(
            _Modal2.default,
            { isOpen: this.props.user.is_local_expert && !this.props.user.accept_cancellation_policy, id: 'cancellation-policy', noClose: true },
            _react3.default.createElement(_CancellationPolicy2.default, { setCancellationPolicy: this.props.setCancellationPolicy })
          ),
          _react3.default.createElement(CountrySelectorModal, { isOpen: this.props.isOpenCountNumUser, onChange: this.handleClassifyUser, onClose: this.handleCloseClassifyUser }),
          _react3.default.createElement(
            _Modal2.default,
            { isOpen: this.props.isOpenWeChatPopup, onClose: function onClose() {
                return _this6.props.openWeChatPopup(false);
              }, centerVertical: true, id: 'wechat' },
            _react3.default.createElement(_WeChat2.default, null)
          ),
          _react3.default.createElement(_Nav2.default, { fullWidth: this.isfullWidth(), hideMenu: this.isHideMenu(), url: { pathname: this.props.path } }),
          _react3.default.createElement(_MobileMenu2.default, null),
          _react3.default.createElement(_Toast2.default, null),
          _react3.default.createElement(_MainLoader2.default, null),
          _react3.default.createElement(
            'div',
            null,
            this.props.children
          ),
          _react3.default.createElement(_Footer2.default, this.props)
        )
      );
    }
  }]);
  return App;
}(_react2.Component), _class2.propTypes = {
  children: _react2.PropTypes.object.isRequired,
  user: _react2.PropTypes.object,
  path: _react2.PropTypes.string,
  headTags: _react2.PropTypes.object,
  pushState: _react2.PropTypes.func.isRequired,
  isOpenLogin: _react2.PropTypes.bool,
  isOpenSignup: _react2.PropTypes.bool,
  isOpenLoginSignup: _react2.PropTypes.bool,
  isOpenForgot: _react2.PropTypes.bool,
  isOpenMobileApp: _react2.PropTypes.bool,
  isOpenMobileQuickSearch: _react2.PropTypes.bool,
  isOpenCountNumUser: _react2.PropTypes.bool,
  sessionData: _react2.PropTypes.object,
  // isOpenSubscribe: PropTypes.bool,
  // isOpenSet: PropTypes.bool,
  verifyEmailPushed: _react2.PropTypes.bool,
  // isOpenCustomizeTripPopup: PropTypes.bool,
  openLogin: _react2.PropTypes.func,
  openSignup: _react2.PropTypes.func,
  openLoginSignup: _react2.PropTypes.func,
  openForgot: _react2.PropTypes.func,
  openMobileApp: _react2.PropTypes.func,
  openCountNumUser: _react2.PropTypes.func,
  // openSubscribe: PropTypes.func,
  openCustomizeTripPopup: _react2.PropTypes.func,
  setCancellationPolicy: _react2.PropTypes.func,
  // openSet: PropTypes.func,
  closeToast: _react2.PropTypes.func,
  closeNotiVerify: _react2.PropTypes.func,
  openNotiVerify: _react2.PropTypes.func,
  blankAction: _react2.PropTypes.func,
  setSessionData: _react2.PropTypes.func,
  setLocalSessionData: _react2.PropTypes.func,
  loadSessionData: _react2.PropTypes.func,
  setText: _react2.PropTypes.func,
  setWithPromo: _react2.PropTypes.func,
  setOldPromo: _react2.PropTypes.func,
  setPromoInput: _react2.PropTypes.func,
  isPageChanged: _react2.PropTypes.bool,
  isVisitBooking: _react2.PropTypes.bool,
  setIsPageChanged: _react2.PropTypes.func,
  query: _react2.PropTypes.object,
  // lockCount: PropTypes.object,
  lockIds: _react2.PropTypes.array,
  locale: _react2.PropTypes.string,
  filter: _react2.PropTypes.object,
  // filterOld: PropTypes.object,
  userConfig: _react2.PropTypes.object,
  pushNotification: _react2.PropTypes.func,
  pushRedeemReminder: _react2.PropTypes.func,
  pushVerifyEmail: _react2.PropTypes.func,
  pushNotiVerify: _react2.PropTypes.func,
  isLoggedIn: _react2.PropTypes.bool,
  sendUserType: _react2.PropTypes.func,
  step: _react2.PropTypes.number,
  data: _react2.PropTypes.object,
  messages: _react2.PropTypes.object,
  context: _react2.PropTypes.object,
  //
  weChatEveryLink: _react2.PropTypes.bool,
  openWeChatPopup: _react2.PropTypes.func,
  isOpenWeChatPopup: _react2.PropTypes.bool,
  toastOAuthLoginSuccess: _react2.PropTypes.func,
  toasts: _react2.PropTypes.array,
  loginSignUpTab: _react2.PropTypes.string,
  getPartnerConfig: _react2.PropTypes.func
}, _class2.contextTypes = {
  store: _react2.PropTypes.object.isRequired
}, _temp)) || _class) || _class));

exports.default = App;

function _inspect(input, depth) {
  var maxDepth = 4;
  var maxKeys = 15;

  if (depth === undefined) {
    depth = 0;
  }

  depth += 1;

  if (input === null) {
    return 'null';
  } else if (input === undefined) {
    return 'void';
  } else if (typeof input === 'string' || typeof input === 'number' || typeof input === 'boolean') {
    return typeof input === 'undefined' ? 'undefined' : (0, _typeof3.default)(input);
  } else if (Array.isArray(input)) {
    if (input.length > 0) {
      if (depth > maxDepth) return '[...]';

      var first = _inspect(input[0], depth);

      if (input.every(function (item) {
        return _inspect(item, depth) === first;
      })) {
        return first.trim() + '[]';
      } else {
        return '[' + input.slice(0, maxKeys).map(function (item) {
          return _inspect(item, depth);
        }).join(', ') + (input.length >= maxKeys ? ', ...' : '') + ']';
      }
    } else {
      return 'Array';
    }
  } else {
    var keys = (0, _keys2.default)(input);

    if (!keys.length) {
      if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
        return input.constructor.name;
      } else {
        return 'Object';
      }
    }

    if (depth > maxDepth) return '{...}';
    var indent = '  '.repeat(depth - 1);
    var entries = keys.slice(0, maxKeys).map(function (key) {
      return (/^([A-Z_$][A-Z0-9_$]*)$/i.test(key) ? key : (0, _stringify2.default)(key)) + ': ' + _inspect(input[key], depth) + ';';
    }).join('\n  ' + indent);

    if (keys.length >= maxKeys) {
      entries += '\n  ' + indent + '...';
    }

    if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
      return input.constructor.name + ' {\n  ' + indent + entries + '\n' + indent + '}';
    } else {
      return '{\n  ' + indent + entries + '\n' + indent + '}';
    }
  }
}

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/App/App.js
// module id = 1651
// module chunks = 47